module.exports = __webpack_public_path__ + "img/btn-tyhd.ac4b2273.png";